// Pure, dependency-free display logic for the MAT/LA group dashboard, so the nav
// visibility rule and the per-school degradation rendering can be unit-tested with
// `node --test` (see groupDisplay.test.js) without a bundler or DOM.

/**
 * Whether the API reports this user as a group admin — the single rule the group
 * dashboard nav entry, its route guard, and the page all gate on. Fail-closed: a
 * missing/empty administeredGroups is not a group admin.
 */
export function isGroupAdmin(user) {
    return (user?.administeredGroups?.length ?? 0) > 0
}

/**
 * Freshness verdict for one fuel of one school, from the summary the API delivers.
 * `no_data` (no meters/readings) wins over `stale` (>7 days old) wins over `fresh`.
 * Returns a stable status plus the chip label/colour the summary list renders.
 */
export function fuelFreshness(fuel) {
    if (!fuel || fuel.no_data) {
        return { status: 'no_data', label: 'No data', color: 'default' }
    }
    if (fuel.stale) {
        return { status: 'stale', label: 'Stale >7d', color: 'warning' }
    }
    return { status: 'fresh', label: 'Fresh', color: 'success' }
}

/** "N of M organisations" coverage string for the group aggregate cards. */
export function coverageLabel(aggregate) {
    if (!aggregate) return ''
    return `${aggregate.contributing_count} of ${aggregate.member_count} organisations`
}
